module.exports = __webpack_public_path__ + "bind.26969b5c1fed2a000d9605571a26dc2c.hashedasset.svg";


//////////////////
// WEBPACK FOOTER
// ./app/components/form/BoundField/bind.svg
// module id = 1556
// module chunks = 8